<template>
    <div class="w-fit max-w-full">
        <Tabs
            :tabs="tabs"
            contentSpacingTop="pt-10"
            :enableReactiveHeightTransition="true"
            :fitWhenSingle="true"
        >
            <template v-for="tab in tabs" v-slot:[tab.id] :tab="tab">
                <div
                    v-html="tab.content"
                    :class="[classes, 'user-written-body max-w-textbody']"
                />
            </template>
        </Tabs>
    </div>
</template>

<script>
import Tabs from '@/Components/Utilities/Tabs.vue'
import ReactiveHeightTransition from '@/Components/Transitions/ReactiveHeightTransition.vue'

export default {
    name: 'DescriptionTabs',

    components: {
        Tabs,
        ReactiveHeightTransition,
    },

    props: {
        tabs: {
            type: Array,
            required: true,
            validator: (value, props) =>
                value.every((tab) => tab.id && tab.name && tab.content),
        },
        classes: {
            type: String,
            required: false,
        },
    },

    data: () => ({
        containerMinHeight: 0,
        activeTabId: null,
    }),

    created() {
        this.activeTabId = this.tabs[0].id
    },
}
</script>
